import React, { Fragment, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./Sidebar";

const AppLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <Fragment>
      <div className="ms-app-layout" id="pageWrapper">
        <Header onHamburgerClick={() => setSidebarOpen(o => !o)} />
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <div className="ms-main-content">
          <div className="ms-page-body">
            <Outlet />
          </div>
          <Footer />
        </div>
      </div>
    </Fragment>
  );
};

export default AppLayout;
